import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApi, restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const designationsAPI = createApi({
    reducerPath: 'designationsAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        searchDesignations: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_DESIGNATION_ACTION}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        listDesignations: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.DESIGNATIONS}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        newDesignation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.NEW_DESIGNATION,
                method: 'POST',
                data,
            }),
        }),
        modifyDesignation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_DESIGNATION,
                method: 'POST',
                data,
            }),
        }),
        newDesignationAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.NEW_DESIGNATION_ACTION,
                method: 'POST',
                data,
            }),
        }),
        bulkNewDesignationAction: builder.mutation({
            queryFn: async (data) => {
                try {
                    const response = await restApi.post(API_ENDPOINTS.BULK_NEW_DESIGNATION_ACTION, data);
                    return { data: response?.data };
                } catch (axiosError) {
                    return {
                        error: {
                            data: axiosError.response?.data || axiosError.message,
                            statusCode: axiosError.response?.status || 500,
                        },
                    };
                }
            },
        }),
        modifyDesignationAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_DESIGNATION_ACTION,
                method: 'POST',
                data,
            }),
        }),
        deleteDesignation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_DESIGNATION,
                method: 'POST',
                data,
            }),
        }),
        viewDesignation: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.VIEW_DESIGNATION,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useSearchDesignationsMutation,
    useListDesignationsMutation,
    useNewDesignationMutation,
    useModifyDesignationMutation,
    useNewDesignationActionMutation,
    useBulkNewDesignationActionMutation,
    useModifyDesignationActionMutation,
    useDeleteDesignationMutation,
    useViewDesignationMutation,
} = designationsAPI;
